import styled from 'styled-components';

/*** Loader styling for segment slider ***/

export const SegmentSliderLoader = styled.div(
  props => `

  display: flex;
  width:100%;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  padding: ${props.theme.spacing.base};
  margin: ${props.theme.spacing.base};
  flex-direction: column;
  width:32rem;

`,
);

export const BannerSliderLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  height:11.5rem;
  margin-bottom :${props.theme.spacing.base};

`,
);

export const SliderContentOuterWrap = styled.div(
  props => `

  display:flex;
  justify-content:space-between;

`,
);

export const SliderContentInnerWrap = styled.div(
  props => `

  // display:flex;

`,
);

export const SliderRatingLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:7rem;
  height:1.5rem;
  margin-bottom :${props.theme.spacing.small};

`,
);

export const SliderAddressLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:15rem;
  height:5rem;
  margin-bottom :${props.theme.spacing.small};

`,
);

export const SliderreviewsLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:7rem;
  height:1.5rem;
  margin-bottom :${props.theme.spacing.small};

`,
);

export const SliderPriceLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:10rem;
  height:7rem;
  margin-bottom :${props.theme.spacing.small};

`,
);

export const SliderOfferLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:7rem;
  height:1.5rem;
  margin-bottom :${props.theme.spacing.small};

`,
);
